

const Flickity = require('flickity-imagesloaded');
const $ = require('./main.js');

// require('jquery-pjax');
let autocomplete;

$(document).ready(($) => {
  $(document).on('click', '.js-modal-op-shop__volunteer-button', function () {
    changeQueryParam("application", "init");
  });

  // live key
  let apiKey = $('#js-op-shops-form').attr('data-google-api-key');
  const mapsUrl = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initAutocomplete`;
  const mapsScript = document.createElement('script');
  mapsScript.async = true;
  mapsScript.src = mapsUrl;
  document.querySelector('head').appendChild(mapsScript);

  window.initAutocomplete = initAutocomplete;

  function initAutocomplete() {
    const input = document.getElementById('advice-autocomplete');

    autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'nz' },
      fields: ['geometry'],
    });

    autocomplete.addListener('place_changed', fillInAddress);
  }

  function fillInAddress() {
    const place = autocomplete.getPlace();
    $('#js-lat').val(place.geometry.location.lat());
    $('#js-lng').val(place.geometry.location.lng());
    localStorage.setItem('opshopAddress', JSON.stringify({
        address: $('#advice-autocomplete').val(),
        lat: $('#js-lat').val(),
        lng: $('#js-lng').val(),
    }));
    $('#js-op-shops-form').submit();
  }
  
  function fillInAddressFromLocalStorage() {
    var opshopAddress = localStorage.getItem('opshopAddress');
    opshopAddress = JSON.parse(opshopAddress);
    if(opshopAddress && opshopAddress.address && !$('#advice-autocomplete').val()){
        //JSON.parse()
        $('#advice-autocomplete').val(opshopAddress.address);
        $('#js-lat').val(opshopAddress.lat);
        $('#js-lng').val(opshopAddress.lng);
        $('#js-op-shops-form').submit();
    }
  }

  $(document).on('submit', '#js-op-shops-form', (event) => {
    event.preventDefault();
    $('.js-op-shops-item-list').html('<div class="wrap no-results loading">' + $('.js-loading-spinner').html() + '</div>');
    // $('.js-volunteers-container').addClass('content-loading');
    $.pjax.submit(event, '.js-op-shops-item-list', {
      fragment: '.js-op-shops-item-list',
      timeout: 6500,
      scrollTo: false,
    });
  });

  $('.js-op-shops-item-list').on('pjax:complete', () => {
    window._ll();
    
  });

  $(document).on('click', '.js-show-opshop-cards', () => {
    $('.js-show-opshop-container').addClass('hidden');
    $('.js-op-shop-card').removeClass('hidden');
    window._ll();
  });

  // -------------------------------------------------------------------------------------------------------
  // Accordions - Why shop with us
  // -------------------------------------------------------------------------------------------------------
  const allAccPanels = $('.js-acc-content');

  $(document).on('click', '.js-acc-heading', function (ev) {
    $('.js-acc-content').removeClass('active');
    ev.preventDefault();
    ev.stopPropagation();

    const $this = $(this);
    allAccPanels.removeClass('active');
    $('.js-acc-heading').not(this).removeClass('active');
    $this.toggleClass('active');
    if ($this.hasClass('active')) {
      $this.next('.js-acc-content').addClass('active');
    }
  });


  // -------------------------------------------------------------------------------------------------------
  // Tabs - Why shop with us
  // -------------------------------------------------------------------------------------------------------
  function Tabs(args) {
    if (!(this instanceof Tabs)) {
      return new Tabs();
    }

    /**
     * @param container {string} Classname for container of the entire component
     * @param trigger {string} Element that toggles content
     * @param content {string} Classname for the content
    */
    const defaults = {
      container: '.js-why-shop-tabs',
      trigger: '[role="tab"]',
      content: '[role="tabpanel"]',
    };

    // If there are no settings overrides
    const settings = (typeof args !== 'undefined') ? args : defaults;

    // Handle the displaying/hiding of content
    const toggle = function () {
      const parent = this.closest(settings.container);
      const target = this.getAttribute('aria-controls');
      const content = document.getElementById(target);
      const toggles = parent.querySelectorAll(settings.trigger);
      const allContent = parent.querySelectorAll(settings.content);

      // Update visibility
      for (let i = 0, len = toggles.length; i < len; i++) {
        toggles[i].setAttribute('aria-selected', 'false');
        allContent[i].setAttribute('aria-hidden', 'true');
      }

      this.setAttribute('aria-selected', 'true');
      content.setAttribute('aria-hidden', 'false');
    };

    // Attach event listeners
    const bindEventListeners = function () {
      const trigger = document.querySelectorAll(settings.trigger);
      for (let i = 0, len = trigger.length; i < len; i++) {
        trigger[i].addEventListener('click', function () {
          toggle.call(this);
        });

        trigger[i].addEventListener('keydown', function (event) {
          if (event.which == 13) {
            toggle.call(this);
          }
        });
      }
    };

    return bindEventListeners();
  }

  const whyShopTabs = new Tabs();

  // -------------------------------------------------------------------------------------------------------
  // Op Shop Modal
  // -------------------------------------------------------------------------------------------------------
  // const urlParams = new URLSearchParams(window.location.search);
  //const shopSlug = urlParams.get('shop');
  const shopSlug = $('#nearest-shops') && $('#nearest-shops').attr('data-opshop') ? $('#nearest-shops').attr('data-opshop') : '';
  console.log(shopSlug);
  if (shopSlug) {
    openOpShopModal(shopSlug, `${window.location.href}`);
  }

  async function openOpShopModal(slug, url) {
    await $('#modal-op-shop div').html($('.js-loading-spinner').html());
    let pageTitle = $('.js-results-container').attr('data-opshop-title');
    $.pjax.reload('#modal-op-shop', {
      // url: '/op-shops/' + slug + window.location.search,
      url, // for prototype only
      fragment: '#modal-op-shop',
      timeout: 6500,
      scrollTo: false,
    });

    $.fancybox.open([{
      type: 'inline',
      src: '#modal-op-shop',
    }], {
      padding: 0,
      smallBtn: false,
      touch: false,
      afterShow() {
        $('.fancybox-toolbar').addClass('compensate-for-scrollbar');
      },
      beforeClose() {
        var opShopSlug = $('.js-slider-gallery').attr('data-opshopslug');
        const updatedUrl = window.location.pathname.replace(`/${opShopSlug}`, '');
        history.pushState({}, '', `${updatedUrl}`);
        document.title = pageTitle
      },
    });
  }

  if ($.support.pjax) {
    $('#modal-op-shop').on('pjax:complete', () => {
      if ($('.js-slider-gallery').length > 0) {
        const flkty = new Flickity('.js-slider-gallery', {
          contain: true,
          setGallerySize: true,
          imagesLoaded: true,
        });

        if ($('.js-caption').length > 0) {
          flkty.on('change', () => {
            $('.js-caption').html($(flkty.selectedElement).find('img').attr('alt'));
          });
        }
      }
    });

    $(document).on('click', '.js-op-shop', function (e) {
      e.preventDefault();
      openOpShopModal($(this).data('slug'), $(this).attr('href'));
    });
  }

  $(document).on('click', '.js-modal-op-shop__volunteer', async () => {
    await $('#js-op-shop-volunteer-form-modal-container div').html($('.js-loading-spinner').html());

    let url = $(this).attr('href');
    $.pjax.reload('#js-op-shop-volunteer-form-modal-container', {
      // url: '/op-shops/' + slug + window.location.search,
      url, // for prototype only
      fragment: '#js-op-shop-volunteer-form-modal-container',
      timeout: 6500,
      scrollTo: false,
    });

    $.fancybox.open([{
      type: 'inline',
      src: '#js-op-shop-volunteer-form-modal-container',
    }], {
      padding: 0,
      smallBtn: false,
      touch: false,
    });
  });

  $(document).on('submit', '#js-op-shop-volunteer-validation-form', (event) => {
    $('#js-op-shop-volunteer-form-modal-container').html($('.js-loading-spinner').html());
    // $('.js-volunteers-container').addClass('content-loading');
    $.pjax.submit(event, '#js-op-shop-volunteer-form-modal-container', {
      fragment: '#js-op-shop-volunteer-form-modal-container',
    });
    // refreshDatePicker()
  });

  $('#js-op-shop-volunteer-form-modal-container').on('pjax:complete', () => {
    jsValidationFormValidate();
    recaptchaInit();
    // refreshDatePicker();

    if ($('#js-op-shop-volunteer-form-thanks').length !== 0) {
      changeQueryParam('application', 'finish');
    }
  });
});
